var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Navbar',{staticClass:"d-print-none"}),_c('v-main',{staticClass:"px-4 pb-4 grey lighten-4 ml-sm-12"},[(!_vm.statusLoggedOut)?_c('router-view'):_vm._e()],1),_c('Footer',{staticClass:"d-print-none"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }